import api from './api';

// Admin Authentication
export const adminLogin = (credentials) => api.post('/api/admin/login', credentials);
export const adminRegister = (adminData) => api.post('/api/admin/register', adminData);

// Admin Dashboard Stats
export const getAdminDashboardStats = () => api.get('/api/admin/dashboard/stats');

// Admin KYC Management
export const getPendingKyc = (page = 0, size = 20) => api.get(`/api/admin/portal/kyc/pending?page=${page}&size=${size}`);
export const getMerchantKycDocs = (merchantId) => api.get(`/api/admin/portal/kyc/${merchantId}/documents`);
export const approveRejectKyc = (merchantId, data) => api.post(`/api/admin/portal/kyc/${merchantId}/approve`, data);

// Admin Dashboard
export const getAdminDashboard = () => api.get('/api/admin/portal/dashboard');

// Admin API Requests Management
export const getPendingApiRequests = (page = 0, size = 20) => api.get(`/api/admin/portal/api-requests/pending?page=${page}&size=${size}`);
export const getAllApiRequests = (page = 0, size = 20) => api.get(`/api/admin/portal/api-requests?page=${page}&size=${size}`);
export const approveRejectApiRequest = (requestId, data) => api.post(`/api/admin/portal/api-requests/${requestId}/approve`, data);

// Admin Recharge Management
export const getPendingRecharges = (page = 0, size = 20) => api.get(`/api/admin/portal/recharge-requests/pending?page=${page}&size=${size}`);
export const getAllRecharges = (page = 0, size = 20) => api.get(`/api/admin/portal/recharge-requests?page=${page}&size=${size}`);
export const approveRejectRecharge = (requestId, data) => api.post(`/api/admin/portal/recharge-requests/${requestId}/approve`, data);

// Admin Merchant Management
export const getMerchants = (page = 1, pageSize = 20, status = '', search = '') => {
  const params = new URLSearchParams();
  if (page) params.append('page', page);
  if (pageSize) params.append('pageSize', pageSize);
  if (status !== undefined && status !== null && status !== 'all') params.append('status', status);
  if (search) params.append('search', search);
  
  return api.get(`/api/admin/merchants?${params.toString()}`);
};
export const getMerchantById = (merchantId) => api.get(`/api/admin/merchants/${merchantId}`);
export const updateMerchant = (merchantId, data) => api.put(`/api/admin/merchants/${merchantId}`, data);
export const createMerchant = (data) => api.post('/api/admin/merchants', data);

// Merchant Commission Management
export const getMerchantCommissionConfigs = (merchantId) => api.get(`/api/admin/merchants/${merchantId}/commission-configs`);
export const createCommissionConfig = (merchantId, data) => api.post(`/api/admin/merchants/${merchantId}/commission-configs`, data);
export const updateCommissionConfig = (merchantId, configId, data) => api.put(`/api/admin/merchants/${merchantId}/commission-configs/${configId}`, data);
export const deleteCommissionConfig = (merchantId, configId) => api.delete(`/api/admin/merchants/${merchantId}/commission-configs/${configId}`);

// Merchant API Management
export const getMerchantApis = (merchantId) => api.get(`/api/admin/merchants/${merchantId}/apis`);
export const enableMerchantApi = (merchantId, data) => api.post(`/api/admin/merchants/${merchantId}/apis`, data);
export const updateMerchantApiMapping = (merchantId, mappingId, data) => api.put(`/api/admin/merchants/${merchantId}/apis/${mappingId}`, data);
export const disableMerchantApi = (merchantId, mappingId) => api.delete(`/api/admin/merchants/${merchantId}/apis/${mappingId}`);

// Merchant IP Management
export const getMerchantWhitelistedIps = (merchantId) => api.get(`/api/admin/merchants/${merchantId}/whitelisted-ips`);
export const addWhitelistedIp = (merchantId, data) => api.post(`/api/admin/merchants/${merchantId}/whitelisted-ips`, data);
export const removeWhitelistedIp = (merchantId, ipId) => api.delete(`/api/admin/merchants/${merchantId}/whitelisted-ips/${ipId}`);

// Merchant Wallet Management
export const rechargeMerchantWallet = (merchantId, data) => api.post(`/api/admin/merchants/${merchantId}/wallet/recharge`, data);
export const creditMerchantWallet = (merchantId, data) => api.post(`/api/admin/merchants/${merchantId}/wallet/credit`, data);
export const debitMerchantWallet = (merchantId, data) => api.post(`/api/admin/merchants/${merchantId}/wallet/debit`, data);
export const manualQrSettlement = (params) => api.post(`/api/admin/digikhata/settle${params ? `?${new URLSearchParams(params).toString()}` : ''}`);
export const getWalletAdjustmentsReport = (params) => api.get(`/api/admin/reports/wallet-adjustments`, { params });
export const regenerateMerchantCredentials = (merchantId) => api.post(`/api/admin/merchants/${merchantId}/regenerate-credentials`);

// Merchant Lien Management
export const getMerchantLien = (merchantId) => api.get(`/api/admin/merchants/${merchantId}/lien`);
export const setMerchantLien = (merchantId, data) => api.post(`/api/admin/merchants/${merchantId}/lien`, data);
export const releaseMerchantLien = (merchantId) => api.delete(`/api/admin/merchants/${merchantId}/lien`);

// Merchant Transactions
export const getMerchantTransactions = (merchantId) => api.get(`/api/admin/merchants/${merchantId}/transactions`);

// Merchant API Logs
export const getMerchantApiLogs = (merchantId) => api.get(`/api/admin/merchants/${merchantId}/api-logs`);

// API Configuration Management
export const getApiConfigs = () => api.get('/api/admin/api-configs');
export const getApiConfigByCode = (apiCode) => api.get(`/api/admin/api-configs/${apiCode}`);
export const updateApiConfig = (apiCode, data) => api.put(`/api/admin/api-configs/${apiCode}`, data);
export const createApiConfig = (data) => api.post('/api/admin/api-configs', data);

// Event Logs
export const getEventLogs = () => api.get('/api/admin/event-logs');

// API Log Details
export const getApiLogDetail = (requestId) => api.get(`/api/admin/api-logs/${requestId}`);

// Admin Bank Management
export const getBanks = () => api.get('/api/admin/portal/banks');
export const createBank = (data) => api.post('/api/admin/portal/banks', data);
export const updateBank = (bankId, data) => api.put(`/api/admin/portal/banks/${bankId}`, data);

// Admin Tickets Management
export const getAdminTickets = (page = 0, size = 20) => api.get(`/api/admin/portal/tickets?page=${page}&size=${size}`);
export const getAdminTicketDetails = (ticketId) => api.get(`/api/admin/portal/tickets/${ticketId}`);
export const updateTicketStatus = (ticketId, data) => api.put(`/api/admin/portal/tickets/${ticketId}`, data);
export const adminReplyToTicket = (ticketId, data) => api.post(`/api/admin/portal/tickets/${ticketId}/reply`, data);

// Payout Reports
export const getPayoutTransactions = (params = {}) => api.get('/api/admin/portal/payouts', { params });
export const getPayoutTransactionDetails = (transactionId) => api.get(`/api/admin/portal/payouts/${transactionId}`);
export const getPayoutStatistics = () => api.get('/api/admin/portal/payouts/stats');

// Additional Admin APIs
export const getTicketsByStatus = (status) => api.get(`/api/admin/portal/tickets/status/${status}`);
